module.exports = __webpack_public_path__ + "static/media/edit.157286d1.svg";